import { createContext, useContext } from 'react'

/**
 * Una comanda que un área marcó como LISTO y todavía no se entregó.
 * Se arma con las notificaciones de cocina (restCocinaNotificaciones).
 */
export interface AvisoCocina {
  /** comandaId:area */
  key: string
  comandaId: string
  /** _id del área (Area); impresora si el artículo no tiene áreas; o GENERAL */
  area: string
  areaNombre: string
  pedidoId: string
  /** Número de orden (o de pedido) */
  numero: number
  /** "Terraza · Mesa 5", "Para llevar"... */
  destino: string
  /** Fecha en que el área marcó LISTO */
  fechaListo: string
  /** Usuario de cocina que lo marcó */
  usuario: string
}

export interface AvisosCocinaContextType {
  /** Avisos pendientes de entrega, el que más espera primero */
  avisos: AvisoCocina[]
  /** Avisos que no fueron minimizados (se muestran en la pila) */
  visibles: AvisoCocina[]
  /** Claves en proceso de entrega */
  procesando: ReadonlySet<string>
  /** Marca el aviso como ENTREGADO en el backend: desaparece en todos los equipos */
  entregar: (aviso: AvisoCocina) => Promise<void>
  entregarTodos: () => Promise<void>
  /** Oculta los avisos actuales de la pila (siguen en la campana). Uno nuevo vuelve a mostrarla */
  minimizar: () => void
  /** Vuelve a mostrar en la pila todos los avisos */
  mostrar: () => void
  sonido: boolean
  setSonido: (activo: boolean) => void
}

export const AvisosCocinaContext = createContext<AvisosCocinaContextType | null>(null)

/** Avisos de pedidos listos en cocina. Debe usarse dentro de AvisosCocinaProvider */
export const useAvisosCocina = () => {
  const context = useContext(AvisosCocinaContext)
  if (!context) throw new Error('useAvisosCocina debe usarse dentro de un AvisosCocinaProvider')
  return context
}

/** Igual que useAvisosCocina, pero devuelve null fuera del provider (componentes opcionales) */
export const useAvisosCocinaOptional = () => useContext(AvisosCocinaContext)
